module.exports = __webpack_public_path__ + "static/media/galerija_2013 (32).551b5875.jpg";